import { render, staticRenderFns } from "./EditIpaModal.vue?vue&type=template&id=60ef6cae&lang=pug&"
import script from "./EditIpaModal.vue?vue&type=script&lang=js&"
export * from "./EditIpaModal.vue?vue&type=script&lang=js&"
import style0 from "./EditIpaModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports